"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiError = void 0;
exports.isApiError = isApiError;
class ApiError extends Error {
    constructor(response) {
        super(response.message || `Request failed with status ${response.statusCode}`);
        this.name = "ApiError";
        this.statusCode = response.statusCode;
        this.errorType = response.type || response.responseType || "UNKNOWN";
        this.fieldErrors = response.errors || [];
        this.rawResponse = response;
        Object.setPrototypeOf(this, ApiError.prototype);
    }
    get displayMessage() {
        if (this.fieldErrors.length === 0)
            return this.message;
        return this.fieldErrors.map(e => e.message).join(" ");
    }
    getFieldError(field) {
        var _a;
        return (_a = this.fieldErrors.find(e => e.field === field)) === null || _a === void 0 ? void 0 : _a.message;
    }
    toFieldErrorMap() {
        return Object.fromEntries(this.fieldErrors.map(e => [e.field, e.message]));
    }
    get isBusinessError() {
        return this.statusCode >= 400 && this.statusCode < 500;
    }
    get isServerError() {
        return this.statusCode >= 500;
    }
    get isConflict() {
        return this.statusCode === 409;
    }
    get isNotFound() {
        return this.statusCode === 404;
    }
    get isForbidden() {
        return this.statusCode === 403;
    }
    static fromAxiosError(e) {
        var _a;
        const data = (_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.data;
        if (!(data === null || data === void 0 ? void 0 : data.statusCode))
            return null;
        return new ApiError(data);
    }
}
exports.ApiError = ApiError;
function isApiError(error) {
    return (error instanceof Error &&
        error.name === "ApiError" &&
        typeof error.statusCode === "number");
}
